module.exports = __webpack_public_path__ + "media/src/images/certificates/generic_coa_sample-fdf301225ed1c20faaeac0dffcec1d36.jpg";